import moment from 'moment';

const currency2 = (value: number) => {
	//console.log('in currency2',value)
	if (value != null && value >= 0) {
		//console.log('in return')
		return value.toLocaleString('en-US', {
			style: 'currency',
			currency: 'USD',
		});
	}
	return null;
};

const prettyDate = (value: any) => {
	return moment(value, ['MM/DD/YYYY', 'YYYY-MM-DDTHH:mm:ss.SSSZ']).format('MM/DD/YYYY');
};

const prettyDateTime = (value: any) => {
	return moment(value, ['MM/DD/YYYY', 'YYYY-MM-DDTHH:mm:ss.SSSZ']).format('MM/DD/YYYY hh:mm ');
};

const prettyNumber = (value: any, decimals?: any) => {
	return value.toLocaleString(undefined, { maximumFractionDigits: decimals });
};

const filters = {
	currency2,
	prettyDate,
	prettyDateTime,
	prettyNumber,
};

export type FiltersPlugin = typeof filters;

export default filters;
